import { LlmTextBlock, Text } from '@websolutespa/bom-mixer-llm';

export type AssistantMessageProps = LlmTextBlock<'assistant'>;

export const AssistantMessage: React.FC<AssistantMessageProps> = (props) => {
  const { text, chunkIndex, index } = props;
  return (
    <div className="llm__row">
      <div className="llm__col --sm-10 --sm-9 --md-8 --lg-7 --xl-6">
        <Text body={text} chunkIndex={chunkIndex} index={index} />
      </div>
    </div>
  );
};

